module.exports = __webpack_public_path__ + "static/media/infrasoft.d3dc86b9.jpeg";